var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('v-list',_vm._l((_vm.bulkAddTypes),function(bulkAddType,index){return _c('v-list-tile',{key:index,on:{"click":function($event){return _vm.clickMenu(bulkAddType)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n            "+_vm._s(bulkAddType)+"\n          ")])],1)],1)}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }